import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, inr } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Badge } from "@/components/ui/badge";

const STATUS_COLOR = {
  pending: "bg-amber-100 text-amber-900",
  confirmed: "bg-blue-100 text-blue-900",
  shipped: "bg-purple-100 text-purple-900",
  delivered: "bg-green-100 text-green-900",
  cancelled: "bg-red-100 text-red-900",
};

export default function Orders() {
  const { user } = useApp();
  const nav = useNavigate();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (!user) { nav("/login?next=/orders"); return; }
    api.get("/orders").then((r) => setOrders(r.data));
  }, [user, nav]);

  if (!user) return null;

  return (
    <div className="max-w-5xl mx-auto px-6 py-12">
      <h1 className="font-display text-4xl font-black mb-8">My Orders</h1>
      {orders.length === 0 ? (
        <p className="text-center text-muted-foreground py-20">No orders yet.</p>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => (
            <div key={o.id} data-testid={`order-${o.order_number}`} className="border border-[#D4B25C]/15 rounded-md p-5 bg-[#2A231D]">
              <div className="flex items-center justify-between flex-wrap gap-2">
                <div>
                  <p className="font-display text-xl">#{o.order_number}</p>
                  <p className="text-xs text-muted-foreground">{new Date(o.created_at).toLocaleString()}</p>
                </div>
                <Badge className={`${STATUS_COLOR[o.status]} uppercase tracking-widest text-[10px] px-3 py-1`}>{o.status}</Badge>
              </div>
              <div className="mt-4 flex flex-wrap gap-4 items-center">
                {o.items.slice(0, 4).map((it, i) => (
                  <img key={i} src={it.image} alt="" className="h-16 w-14 object-cover rounded" />
                ))}
                {o.items.length > 4 && <span className="text-xs text-muted-foreground">+{o.items.length - 4} more</span>}
              </div>
              <div className="mt-4 flex justify-between items-center border-t border-white/10 pt-3">
                <span className="text-sm text-muted-foreground">Payment: <span className="font-semibold text-foreground">{o.payment_method.toUpperCase()}</span> {o.tracking && `· Track: ${o.tracking}`}</span>
                <span className="font-bold text-lg text-[#D4B25C]">{inr(o.total)}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
